import Echo from 'laravel-echo';

export function initializePusher(environmentVars) {
    const {environment, hasAccessToken, pusherKey, userId} = environmentVars;

    // Enable pusher logging - don't include this in production
    if (environment !== 'production') {
        window.Pusher.logToConsole = true;
    }

    if (pusherKey && pusherKey.length > 0 && hasAccessToken && userId) {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: pusherKey,
            cluster: 'us2',
            forceTLS: true,
            authEndpoint: '/api/?entity=broadcasting&action=getBroadcastingAuth',
        });

        window.pusherUserChannel = window.Echo.private('user.' + userId);
        const message = {type: 'pusherUserChannel'};
        window.postMessage(message, window.location.origin);
    }
}
